import React from "react";
import { Button, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CustomModal = ({
  icon,
  header,
  content,
  isModalOpen,
  onCancelClick,
  onSubmitClick,
  btnTextSecondary,
  btnTextPrimary,
  size = "smd",
  color = "black",
  iconSize = "3x",
  btnColor,
}) => {
  const btnPrimary = {
    backgroundColor: btnColor,
    color: "#fff",
    border: `2px solid ${btnColor}`,
  };
  const btnSecondary = {
    backgroundColor: "#fff",
    color: btnColor,
    border: `2px solid ${btnColor}`,
  };
  return (
    <Modal show={isModalOpen} size={size}>
      <Modal.Body>
        <div className="d-flex">
          <div className="pd-15">
            <FontAwesomeIcon
              icon={icon}
              color={color}
              size={iconSize}
              className="mt-3"
            />
          </div>
          <div className="remove-text">
            <h4>{header}</h4>
            <p>{content}</p>
            <br />
            <Button
              variant="secondary"
              onClick={() => onCancelClick()}
              className="ml-5 mr-3"
              style={btnSecondary}
            >
              {btnTextSecondary}
            </Button>
            <Button
              style={btnPrimary}
              variant="primary"
              onClick={() => onSubmitClick()}
            >
              {btnTextPrimary}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CustomModal;
